import {Injectable} from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {ParametrosConst} from 'src/app/util/parametrosConst';

@Injectable({
  providedIn: 'root'
})
export class AuthCliente implements CanActivate {

  constructor(private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (localStorage.getItem(ParametrosConst.USUARIO_CLIENTE) != null) {
      return true;
    }
    // not logged in so redirect to login page with the return url
    this.router.navigate(['/validacion'], {queryParams: {returnUrl: state.url}});
    return false;
  }
}
